export const formatSynaDate = (dateString: string): string => {
  if (!dateString) {
    return dateString;
  }
  const strArray = dateString.split('');
  strArray.splice(6, 0, '-');
  strArray.splice(4, 0, '-');
  const date = new Date(strArray.join(''));
  return isValidDate(date) ? date.toLocaleDateString('sv-SE') : dateString;
};

const isValidDate = (date: Date): boolean => {
  return date instanceof Date && isFinite(+date);
};
